import type { QuizQuestion } from '@efdigital/ll-addon-data';
import { type TemplateOnlyComponent } from '@ember/component/template-only';
import { fn } from '@ember/helper';

import EditModeToggle from './edit-mode-toggle.gts';
import type { QuestionManager } from './types/question-manager.ts';
import type { EditingMode } from './utils.ts';

const QuestionEditorButtonsOutput: TemplateOnlyComponent<{
  Args: {
    question: QuizQuestion;
    index: number;
    isEditing: boolean;
    manager: QuestionManager;
    isEditingMode: (index: number, mode: EditingMode) => boolean;
    setEditingMode: (
      question: QuizQuestion | null,
      index: number,
      mode: EditingMode
    ) => void;
  };
}> = <template>
  <div
    class="btn-group bg-primary-subtle shadow-sm question-editor-buttons-container
      {{if @isEditing 'is-editing'}}"
  >
    {{#if @manager.scoringComponent}}
      <EditModeToggle
        @isActive={{@isEditingMode @index "scoring"}}
        @icon="ph:sigma"
        @buttonText="Scoring"
        @onActivate={{fn @setEditingMode @question @index "scoring"}}
        @onDeactivate={{fn @setEditingMode null -1 "inactive"}}
      />
    {{/if}}

    {{#if @manager.responseComponent}}
      <EditModeToggle
        @isActive={{@isEditingMode @index "response"}}
        @icon="ph:chat-centered-text"
        @buttonText="Responses"
        @onActivate={{fn @setEditingMode @question @index "response"}}
        @onDeactivate={{fn @setEditingMode null -1 "inactive"}}
      />
    {{/if}}

    <EditModeToggle
      @isActive={{@isEditingMode @index "reporting"}}
      @icon="ph:table-duotone"
      @buttonText="Reporting"
      @onActivate={{fn @setEditingMode @question @index "reporting"}}
      @onDeactivate={{fn @setEditingMode null -1 "inactive"}}
      class="rounded-end-0"
    />
  </div>
</template>;

export default QuestionEditorButtonsOutput;
